import { ApplicationConfig, provideZoneChangeDetection, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { routes } from './app.routes';
import { requestAuthInterceptor, responseInterceptor, SPECTRUM_API_PATH, SPECTRUM_AUTH_API, provideSpectrumGuide } from 'common';
import { environment } from '../environments/environment';
import { LUCIDE_ICONS, LucideIconProvider } from 'lucide-angular';
import {
    LayoutDashboard, Send, Megaphone, Inbox, Pin, FileText, BarChart3, Settings,
    Calendar, CalendarDays, ChevronDown, ChevronRight, ChevronLeft, Plus, Check, X,
    Menu, Bell, PanelLeftClose, PanelLeftOpen, AlertCircle, Search, Clock, Users,
    ShieldCheck, Paperclip, Eye, Phone, Mail, Trash2, Save, RefreshCw, MessageSquare,
    Zap, CheckCheck, Languages, IndianRupee, UserCheck, Filter, Download
} from 'lucide-angular';

export const appConfig: ApplicationConfig = {
    providers: [
        provideSpectrumGuide({
            module: 'message-center',
            title: 'Message Center',
            manual: () => import('./help/message-center.manual').then(m => m.MESSAGE_CENTER_MANUAL)
        }),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideBrowserGlobalErrorListeners(),
        provideRouter(routes),
        provideHttpClient(withInterceptors([requestAuthInterceptor, responseInterceptor])),
        provideAnimations(),
        { provide: SPECTRUM_API_PATH, useValue: environment.externalApiPath },
        { provide: SPECTRUM_AUTH_API, useValue: environment.authBaseUrl },
        {
            provide: LUCIDE_ICONS,
            multi: true,
            useValue: new LucideIconProvider({
                LayoutDashboard, Send, Megaphone, Inbox, Pin, FileText, BarChart3, Settings,
                Calendar, CalendarDays, ChevronDown, ChevronRight, ChevronLeft, Plus, Check, X,
                Menu, Bell, PanelLeftClose, PanelLeftOpen, AlertCircle, Search, Clock, Users,
                ShieldCheck, Paperclip, Eye, Phone, Mail, Trash2, Save, RefreshCw, MessageSquare,
                Zap, CheckCheck, Languages, IndianRupee, UserCheck, Filter, Download
            })
        }
    ]
};
